import { CongratulationScreen } from '@/global/components/CongratulationScreen';
import { FC, useEffect } from 'react';

type SourceConnectorConfirmationStepProps = {
  onInit?: VoidFunction;
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  isModal?: boolean;
};

export const SourceConnectorConfirmationStep: FC<SourceConnectorConfirmationStepProps> = ({ onNextStep, onPrevStep, onInit, isModal }) => {
  useEffect(() => {
    onInit?.();
  }, [onInit]);

  return (
    <CongratulationScreen
      title='data_source_edit.code.installation_success.data_source_created_succesfully'
      subtitle='data_source_edit.code.installation_success.data_source_created_succesfully_subtitle'
      primaryButton={
        isModal
          ? {
              text: 'data_source_edit.code.installation_success.choose_destination',
              onClick: onNextStep,
            }
          : {
              text: 'data_source_edit.code.installation_success.create_new_campaing',
              onClick: onNextStep,
            }
      }
      secondaryButton={
        isModal
          ? {
              text: 'data_source_edit.code.installation_success.add_another_data_source',
              onClick: onPrevStep,
            }
          : {
              text: 'data_source_edit.code.installation_success.view_all_data_sources',
              onClick: onPrevStep,
            }
      }
    />
  );
};
